import { PlaylistForm } from '../features/savedItems';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatePlaylist = () => {
  return /*#__PURE__*/_jsx(PlaylistForm, {
    action: "create"
  });
};
export default CreatePlaylist;